<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <b-link class="navbar-brand" to="/" ref="logo"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarMinimize">&#9776;</button>
    <!--<button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">&#9776;</button>
    <b-navbar-nav>
      <b-nav-item>
        <b-input-group class="search-bar d-md-down-none">
          <b-form-input variant="outline-secondary"></b-form-input>
          <b-input-group-button slot="right">
            <b-btn variant="outline-secondary" style="border-radius='0 5px 5px 0'">Search</b-btn>
          </b-input-group-button>

        </b-input-group>
      </b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto mr-2">
      <b-nav-item-dropdown :text="currentBot" right>
        <b-dropdown-item href="#" v-for="(value, key) in bots" @click="changeBot(key)" :key="key">{{key}}</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>-->
  </header>
</template>
<script>
import { metadb } from '@/firebase' // , notif, auth, testdb
import { mapGetters } from 'vuex'

const bots = metadb.ref('bots')

export default {
  name: 'app-header',
  data() {
    return {
      bots: [],
      currentBot: null,
    }
  },
  mounted: function() {
    bots.once('value').then((snapshot) => {
      this.bots = snapshot.val()
      this.changeBotInfo()
    })
    this.$store.dispatch('setRef')
    // notif.requestPermission()
    //   .then(function() {
    //     // console.log('Have permission to push notification')
    //     return notif.getToken()
    //   })
    //   .then(function(token) {
    //     // console.log(token)
    //     // console.log(auth.currentUser.uid)
    //     metadb.ref('users/' + auth.currentUser.uid).update({
    //       fcmToken: token,
    //     })
    //   })
    //   .catch(function(err) {
    //     console.log('Permission to push notification denied: ', err)
    //   })
    // notif.onMessage(function(payload) {
    //   // console.log('Message received: ', payload)
    // })
  },
  computed: {
    ...mapGetters(['users']),
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    changeBot: function(botName) {
      // this.$store.commit('switchBot', botName)
      this.$store.dispatch('changeFBRef', botName)
      this.changeBotInfo()
      // testdb(this.bots[botName], botName)
    },
    changeBotInfo: function() {
      this.currentBot = this.$store.state.bot
      var logoURL = this.bots[this.currentBot].logoURL
      this.$refs.logo.$el.style.backgroundImage = 'url(' + logoURL + ')'
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue?43ae92cf